
import './Footer.css';

import aulogo from './au-logo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="Footer">
            <div className="au-logo">
                <img src={aulogo} alt="Auburn University" />
            </div>
            <div style={{display: "inline-block"}}>
                <ul>
                    <li><Link to="/~aesmith/">About</Link></li>
                    <li><Link to="/~aesmith/research">Research</Link></li>
                    <li><Link to="/~aesmith/professional-activities">Professional Activities</Link></li>
                    <li><Link to="/~aesmith/publications">Publications</Link></li>
                </ul>
            </div>
            <div style={{display: "inline-block"}}>
                <ul>
                    <li><Link to="/~aesmith/graduate-students">Graduate Students</Link></li>
                    <li><Link to="/~aesmith/visiting-scholars">Visiting Scholars</Link></li>
                    <li><a href="https://scholar.google.com/citations?user=3WhioLIAAAAJ&hl=en" target='_blank' rel="noreferrer">Google Scholar</a></li>
                    <li>&#8203;</li>
                </ul>
            </div>
            <div className="contact-container">
                <div className="name">ALICE E. SMITH</div>
                <div className="contact">3301P Shelby Center<br/>
                Auburn, AL 36849, USA<br />
                smithae@auburn.edu
                </div>
            </div>
        </div>

    )
}

export default Footer;

